<!-- <div class="header pb-8 pt-5 pt-md-7" style="background: rgb(1, 58, 133);">
  <div class="header pb-8 pt-5 pt-md-7" style="background: #F68891;">
  <div class="container-fluid">
    <div class="header-body">

        <div class="row">
        <div class="col s6">
          <i class="material-icons prefix">dashboard</i>
          <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-white-teal z-depth-4 mr-1 mb-2'
            href='#' data-target='ddl_format' style="min-width:150px; margin-left: 22px; background-color: #bbf0ee;">
            <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
            <span *ngIf="formatSelected">{{formatSelected.title}}</span>
          </a>
          <ul id='ddl_format' class='dropdown-content'>
            <li (click)="formatSelect(rec)" *ngFor="let rec of formats; let iRec = index;">
              <a href="javascript:void(0);" class="li_area">{{rec.value}}</a>
            </li>
          </ul>
        </div>

        <div class="col s6">
          <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-white-teal z-depth-4 mr-1 mb-2'
            href='#' data-target='ddl_dashboard_areas' style="min-width:150px; margin-left: 22px; background-color: #ecedf3;">
            <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
            <span *ngIf="area">{{area.areaName}}</span>
          </a>
          <ul id='ddl_dashboard_areas' class='dropdown-content'>
            <li (click)="areaSelect(rec)" *ngFor="let rec of pageData.areas; let iRec = index;">
              <a href="javascript:void(0);" class="li_area">{{rec.areaName}}</a>
            </li>
          </ul>
        </div>

      </div>  
      
     

      <div class="col s12 m6">
        <input (dateTimeChange)="dateChange($event)" [(ngModel)]="selectedMoment" [owlDateTime]="dt1" style="width: 90px;">
        <span class="trigger" [owlDateTimeTrigger]="dt1">
          <i class="material-icons tatt-i-btn">date_range</i>
        </span>
        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
      </div>
      <div class="col s12 m6">
        <input (dateTimeChange)="compareDateChange($event)" [(ngModel)]="compareSelectedMoment" [owlDateTime]="dt2" style="width: 90px;">
        <span class="trigger" [owlDateTimeTrigger]="dt2">
          <i class="material-icons tatt-i-btn">date_range</i>
        </span>
        <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
      </div>

      <div class="row mt-4">
        <div class="col-xl-6 col-lg-6">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">Traffic</h5>
                  <span class="h2 card-value font-weight-bold mb-0">{{pageData.inValue}}</span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-blue text-white rounded-circle shadow">
                    <i class="fas fa-chart-line"></i>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span *ngIf="dataHis.inValue > pageData.inValue" class="text-danger mr-2"><i class="fas fa-arrow-down"></i> {{dataHis.inValue}}</span>
                <span *ngIf="pageData.inValue > dataHis.inValue" class="text-success mr-2"><i class="fas fa-arrow-up"></i> {{dataHis.inValue}}</span>
                <span *ngIf="pageData.inValue == dataHis.inValue" class="text-success mr-2"><i class="fas fa-arrow-up"></i> {{dataHis.inValue}}</span>
                <span class="text-nowrap">vs last week</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">Peak Hour</h5>
                  <span class="h2 card-value font-weight-bold mb-0">{{peakHourTitle}}</span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-warning text-white rounded-circle shadow">
                    <i class="fas fa-clock"></i>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="text-success mr-2"><i class="fas fa-clock"></i> {{dataHis.peakHourTitle}}</span>
                <span class="text-nowrap">vs last week</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6" hidden="hidden">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">AVG. DWELL TIME</h5>
                  <span class="h2 card-value font-weight-bold mb-0">{{dwelltimeMinute/60 | number:'1.1-1'}}  Min</span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-info text-white rounded-circle shadow">
                    <i class="fas fa-clock"></i>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="text-success mr-2"><i class="fas fa-arrow-up"></i> {{dwelltimeMinuteLastWeek/60 | number:'1.1-1'}}  Min</span>
                <span class="text-nowrap">vs last week</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt--7">
  <div class="row">
    <div class="col-xl-6 mb-5 mb-xl-0">
      <div class="card bg-gradient-default shadow">
        <div class="card-header bg-transparent">
          <div class="row align-items-center">
            <div class="col">
              <h6 class="text-uppercase text-light ls-1 mb-1">Hourly Breakdown</h6>
              <h2 class="text-white mb-0">Occupancy</h2>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="chart">
            <canvas id="chtSales" #chtSales id="chart-sales" class="chart-canvas"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6">
      <div class="card shadow">
        <div class="card-header bg-transparent">
          <div class="row align-items-center">
            <div class="col">
              <h6 class="text-uppercase text-muted ls-1 mb-1">Hourly Breakdown</h6>
              <h2 class="mb-0">Traffic</h2>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="chart" id="divchtord">
            <canvas id="chtOrders" #chtOrders id="chart-orders" class="chart-canvas"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5"> 
    <div class="col-xl-12">
      <div class="card shadow" style="background-color: #2f2241;">
        <div class="card-header bg-transparent">
          <div class="row align-items-center">
            <div class="col">
              <h2 class="mb-0 text-white">Top Entrances</h2>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="chart" style="height: 200px;" id="divchtte">
            <canvas #chtTe id="chtTe" class="chart-canvas"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-xl-12 mb-5 mb-xl-0">
      <div class="card shadow">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="mb-0">Hourly Breakdown</h3>
            </div>
            <div class="col text-right">
              <a href="javascript:void(0)" (click)="dataExportCsv($event)" class="btn btn-sm btn-primary">CSV</a>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th scope="col">Hour</th>
                <th scope="col">Traffic</th>
                <th scope="col">Occupancy</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rec of dataLevel4">
                <td>{{rec.h}}</td>
                <td>{{rec.t}}</td>
                <td>{{rec.o}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-xl-4" *ngIf="false">
      <div class="card shadow">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="mb-0">Social traffic</h3>
            </div>
            <div class="col text-right">
              <a href="#!" class="btn btn-sm btn-primary">See all</a>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th scope="col">Referral</th>
                <th scope="col">Visitors</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  Facebook
                </th>
                <td>
                  1,480
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="mr-2">60%</span>
                    <div>
                      <div class="progress">
                        <div class="progress-bar bg-gradient-danger" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%;"></div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  Facebook
                </th>
                <td>
                  5,480
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="mr-2">70%</span>
                    <div>
                      <div class="progress">
                        <div class="progress-bar bg-gradient-success" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%;"></div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  Google
                </th>
                <td>
                  4,807
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="mr-2">80%</span>
                    <div>
                      <div class="progress">
                        <div class="progress-bar bg-gradient-primary" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%;"></div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  Instagram
                </th>
                <td>
                  3,678
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="mr-2">75%</span>
                    <div>
                      <div class="progress">
                        <div class="progress-bar bg-gradient-info" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 75%;"></div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  twitter
                </th>
                <td>
                  2,645
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="mr-2">30%</span>
                    <div>
                      <div class="progress">
                        <div class="progress-bar bg-gradient-warning" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style="width: 30%;"></div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div> -->



<div class="row">
  <div class="col s12 m6">
    <h4 class="card-title">Dashboard</h4>
  </div>
</div>
<div class="row">
  <div class="col s12 m3">
    <input (dateTimeChange)="dateChange($event)" [(ngModel)]="selectedMoment" [selectMode]="'range'" [owlDateTime]="dt1" style="width: 220px;">
    <span class="trigger" [owlDateTimeTrigger]="dt1">
      <i class="material-icons tatt-i-btn">date_range</i>
    </span>
    <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
  </div>
  <div class="col s12 m3">
    <input (dateTimeChange)="compareDateChange($event)" [(ngModel)]="compareSelectedMoment" [selectMode]="'range'" [owlDateTime]="dt2" style="width: 220px;">
    <span class="trigger" [owlDateTimeTrigger]="dt2">
      <i class="material-icons tatt-i-btn">date_range</i>
    </span>
    <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
  </div>

  <div class="col s12 m3">
    <i class="material-icons prefix">dashboard</i>
    <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mr-1 mb-2'
      href='#' data-target='ddl_format' style="min-width:150px; margin-left: 22px; background-color: #bbf0ee;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="formatSelected">{{formatSelected.title}}</span>
    </a>
    <ul id='ddl_format' class='dropdown-content'>
      <li (click)="formatSelect(rec)" *ngFor="let rec of formats; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec.value}}</a>
      </li>
    </ul>
  </div>

  <div class="col s12 m3" style="display: flex; justify-content: flex-end; align-items: center;">
    <!-- <i (click)="pageData.autoRefresh = !pageData.autoRefresh" class="material-icons tatt-i-btn mr-1" [ngClass]="{'icon-light-blue': pageData.autoRefresh}">refresh</i> -->
    <a class='hide dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mb-2' href='#' data-target='ddl_dashboard_areas' style="min-width:158px;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="!area">-- ALL --</span>
      <span *ngIf="area">{{area.areaName}}</span>
    </a>
    <!-- Dropdown Structure -->
    <ul id='ddl_dashboard_areas' class='dropdown-content'>
      <li (click)="areaSelect(rec)" *ngFor="let rec of pageData.areas; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec.areaName}}</a>
      </li>
    </ul>
    <div style="max-width: 400px;">
      <select class="ddl-001" (change)="areaSelectDdl($event.target.value)">
        <option *ngFor="let rec of pageData.areas; let iRec = index;" [ngValue]="iRec">{{rec.areaName}}</option>
      </select>
    </div>
  </div>
</div>
<div>
  
<div class="row">
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm6': !isShowDTD}">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.inValue}}</h5>
          <p class="no-margin">Entry Total</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-shadow gradient-45deg-light-blue-cyan white-text">people</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.inValue>0">{{dataHis.inValue}}</span>
            <span *ngIf="dataHis.inValue<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 14 hide" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}" *ngIf="pageData.isToday">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.outValue}}</h5>
          <p class="no-margin">Exit Total</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-purple-deep-orange gradient-shadow white-text">people_outline</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.outValue>0">{{dataHis.outValue}}</span>
            <span *ngIf="dataHis.outValue<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 14 hide" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}" *ngIf="!pageData.isToday">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.maxOccupancy}}</h5>
          <p class="no-margin">Max Occupancy</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-purple-deep-orange gradient-shadow white-text">people_outline</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.maxOccupancy>0">{{dataHis.maxOccupancy}}</span>
            <span *ngIf="dataHis.maxOccupancy<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm6': !isShowDTD}">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{peakHourTitle}}</h5>
          <p class="no-margin">Peak Hour</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-deep-orange-orange gradient-shadow white-text">timer</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">{{dataHis.peakHourTitle}}</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isShowDTD" class="col s12 m3 14">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{dwelltimeMinute/60 | number:'1.1-1'}}  Min</h5>
          <p class="no-margin">Dwell Time</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-deep-white-white gradient-shadow white-text">timer</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">{{dwelltimeMinuteLastWeek/60 | number:'1.1-1'}}  Min</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m4 l4 hide">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0"></h4>
        <p class="medium-small"></p>
        <div class="pnl-chart-pie-01">
          <div class="chart-pie-01"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">

  <div class="col s12 m12 14">
    <div class="card animate fadeleft">
    <div class="card-content"  id="pdfchtSales" #pdfchtSales>
      <div class="row">
        <div class="col s6">
          <h6 class="card-title mb-0">Hourly Breakdown - Occupancy</h6>
        </div>
        <div class="col s6">
        <a (click)="downloadAsPDF('chtSales')" class="card-title waves-effect waves-light gradient-45deg-grey-teal btn ml-1 right">
          Export PDF
        </a>
        </div>
      </div>
      <!-- <div class="card-body"> -->
        <!-- <div class="chart"> -->
        <div  style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtSales" #chtSales class="chart-canvas"></canvas>
        </div>
      <!-- </div> -->
    </div>
    </div>
  </div>

  <div class="col s12 m12 14">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtOrders" #pdfchtOrders>
        <div class="row">
          <div class="col s6">
            <h4 class="card-title mb-0">Hourly Entry</h4></div>
          <div class="col s6">
          <a (click)="downloadAsPDF('chtOrders')" class="card-title waves-effect waves-light gradient-45deg-grey-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtOrders" #chtOrders class="chart-canvas"></canvas>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m12">
    <div *ngIf="isLoading">
      <div class="preloader-wrapper small active">
        <div class="spinner-layer spinner-blue-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtTe" #pdfchtTe>
        <div class="row">
          <div class="col s6">
            <h4 class="card-title mb-0">Top Entrances</h4></div>
          <div class="col s6">
          <a (click)="downloadAsPDF('chtTe')" class="card-title waves-effect waves-light gradient-45deg-grey-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div>
        <div class="chart-container" style="position: relative; margin-top: 15px; margin-left: 18px;">
          <canvas #chtTe id="chtTe" class="chart-canvas"></canvas>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m12 14 hide">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtLineExit" #pdfchtLineExit>
        <div class="row">
          <div class="col s6"><h4 class="card-title mb-0">Hourly Exit</h4></div>
          <div class="col s6"><a (click)="downloadAsPDF('chtLineExit')" class="card-title waves-effect waves-light gradient-45deg-green-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtLineExit" #chtLineExit></canvas>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 m12 14 hide">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtLineOccupancy" #pdfchtLineOccupancy>
        <div class="row">
          <div class="col s6"><h4 class="card-title mb-0">Hourly Occupancy</h4></div>
          <div class="col s6"><a (click)="downloadAsPDF('chtLineOccupancy')" class="card-title waves-effect waves-light gradient-45deg-green-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtLineOccupancy" #chtLineOccupancy></canvas>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isShowDTD" class="col s12 m12 14">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0">Hourly Dwell Time</h4>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas #chtLineHourlyDwellTime></canvas>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m12 14">
    <div class="card shadow">
      <div class="card-header border-0">
          <div class="row">
            <div class="col s6">
              <h4 class="card-title mb-0">Hourly Breakdown</h4>
            </div>
            <div class="col s6">
              <a (click)="downloadTblAsPDF()" class="btn btn-sm btn-primary card-title mt-2 mb-0 right">
              Export PDF
            </a>
            <a href="javascript:void(0)" (click)="dataExportCsv()" class="btn btn-sm btn-primary card-title mt-2 mb-0 mr-2 right">CSV</a>
            </div>
          </div>
      </div>
      <div class="table-responsive" id="pdfTable" #pdfTable>
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th style="width: 20%;" scope="col">Hour</th>
              <th style="width: 20%;" scope="col">Traffic</th>
              <th style="width: 20%;" scope="col">Occupancy</th>
              <!-- <th style="width: 20%;" scope="col">Compare Hour</th> -->
              <th style="width: 20%;" scope="col">Compare Traffic</th>
              <th style="width: 20%;" scope="col">Compare Occupancy</th>
              <!-- <th style="width: 16%;" scope="col">Compare Occupancy</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rec of dataLevel4">
              <td>{{rec.h}}</td>
              <td>{{rec.t}}</td>
              <td>{{rec.o}}</td>
              <!-- <td>{{rec.hh}}</td> -->
              <td>{{rec.ht == 0 ? '' : rec.ht}}</td>
              <td>{{rec.ho}}</td>
              <!-- <td>{{rec.ho}}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>